import React from 'react';
import NavButton from '../../homepage/header-banner/TopNavButton';
import TrafficFee from '../../homepage/header-banner/TrafficFee';
import MySql from '../../homepage/header-banner/MySql';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import CardBox from '../../container/Box/Components/CardBox'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import ClickHouse from '../../homepage/header-banner/ClickHouse';
import '../../Style/typo.css'
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import BannerPrivateCloudENG from '../../container/Banner/banner-privateCloud-en';
import Cloudconsult2ENG from '../../homepage/consult/cloudconsult-2-en';
import SidebarENG from '../../container/Sidebar/Sidebar-en';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import { useEffect } from 'react';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

function ClusterclickhouseENG() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Private ClickHouse Cluster - Private Kubernetes - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudENG />
            <Container className='main-body'>
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarENG />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for ClickHouse")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}

                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Open-source Columnar DBMS for Real-time Online Analytical Processing (OLAP)</p>",
                                `<p class="typo-14">Data is written to available nodes, and then replicated across all nodes in the system.</p>
                                <p class="typo-14">Capable of storing and processing petabyte-scale data.</p>
                                <p class="typo-14">Provides over 100 times the speed of traditional DBMS, making it ideal for real-time online data analysis.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Distributes data across shards and supports asynchronous multi-master replication</p>",
                                `<p class="typo-14">Supports multi-master asynchronous replication,  allowing data collection from any replicated node.</p>
                                <p class="typo-14">Stores data across shards, executing operations in parallel and merging results efficiently.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Operates on high-performance Persistent Volumes with optimized I/O for maximum efficiency</p>",
                                `<p class='typo-14'>Runs on SSD-based PV volumes, with three replicas (containers/PODs) forming a single service unit.</p>
                                <p class='typo-14'>In case of hardware failures on worker nodes, service continues seamlessly on replica containers (PODs) on other nodes.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Provides a zero-downtime system by automatically reassigning containers (PODs) to other worker nodes during hardware failure</p>",
                                `<p class="typo-14">Kubernetes ClickHouse containers (PODs) are configured with 3 replica nodes per service unit.</p> 
                                <p class="typo-14">Each replica container (POD) is distributed across multiple Kubernetes worker nodes to ensure resilience and scalability.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Automatically scales out (autoscaling) to expand containers and distribute service load effectively</p>",
                                `<p class='typo-14'>Periodically adjusts (increments or decrements) the number of containers (PODs) based on CPU usage, memory, or other custom metrics.</p>
                                <p class='typo-14'>Enables service expansion without the need for additional hardware resources.</p>
                                <p class='typo-14'>Offers a cluster solution that efficiently distributes load and optimizes costs.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>{Imagecloudcompute("https://hanbiro.com/cloud/library/cluster-clickhouse/clickhouse.jpeg")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        {/* <ClickHouse />
                        <TrafficFee /> */}
                        {/* <CloudconsultCp /> */}
                        <Cloudconsult2ENG />
                    </Col>
                </Row>
            </Container>
            {/* <Cloudconsult /> */}
            {/* <Footer /> */}
            <FooterEn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default ClusterclickhouseENG;
